import styled from "styled-components";

export const ErrorMessageWarning = styled.div`
  color: ${(p) => p.theme.colors.black80};
  padding: 12px 16px;
  border: 1px solid ${(p) => p.theme.colors.error40};
  border-radius: 4px;
  background-color: ${(p) => p.theme.colors.error10};
`;
